import styled from "styled-components";

export const BlogDescription = styled.div`
  padding-bottom: 36px;
  // p {
  //   font-size: 16px;
  //   line-height: 1.6;
  // }
  ul {
    li {
      // font-size: 16px;
      // line-height: 1.1;
      position: relative;
      padding-left: 12px;
      margin-bottom: 8px;
      &:after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 8px solid #58a4ae;
        left: 0;
        bottom: 0;
        top: 0;
        margin: auto;
      }
    }
  }
  h3 {
    padding-top: 24px;
    margin-bottom: 8px;
  }
  a {
    color: #58a4ae;
  }
  @media (min-width: 1024px) {
    padding-bottom: 40px;
    // p {
    //   font-size: 18px;
    // }
    h3 {
      padding-top: 32px;
      margin-bottom: 12px;
    }
    ul {
      li {
        padding-left: 16px;
        margin-bottom: 12px;
        // font-size: 18px;
      }
    }
  }
`;

export const LocationInfo = styled.div`
  .label {
    font-weight: 700;
  }
  .value {
    opacity: 0.8;
  }
`;

export const ImageBox = styled.div`
  border-radius: 8px;
  overflow: hidden;
  img {
    object-fit: cover;
  }
  media(min-width: 1024px) {
  }
`;

// export const Gwrap = styled.div`
// background-image: linear-gradient(#c6e7f8, #67b6cb);

// `
// export const GalleryWrap = styled.div`
//   position: relative;
//   .image-gallery-content {
//     * {
//       max-height: 545px;
//     }
//     &.fullscreen {
//       * {
//         max-height: calc(100vh - 80px);
//       }
//     }
//       img {
//           width: 688px;
//           height: auto;
//           max-height: none;
//       }
//   }
//   overflow: hidden;
//   .image-gallery {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
// `;

// export const Box = styled.div`
//   position: relative;
//   border: 2px solid #58a4ae;
//   height: 300px;
//   width: 45%;
//   border-radius: 8px;
//   padding: 8px;
//   background: #fff;
//   .circle {
//     width: 60px;
//     height: 60px;
//     border-radius: 50%;
//     box-shadow: inset 7px 7px 11px #58a4ae;
//     display: flex;
//     -webkit-box-align: center;
//     align-items: center;
//     justify-content: center;
//     background: #fff;
//     position: absolute;
//     top: -25px;
//     left: -25px;
//     font-size: 38px;
//   }
//   .title {
//     // color: #58a4ae;
//     color: #4a4a4a;
//     font-size: 30px;
//     margin-bottom: 8px;
//     position: relative;
//     z-index: 2;
//   }
//   .description {
//     font-size: 18px;
//     letter-spacing: 0.5px;
//   }
//   @media (max-width: 767px) {
//     width: 100%;
//     height: fit-content;
//     .circle {
//       width: 40px;
//       height: 40px;
//       top: -13px;
//       left: -13px;
//       font-size: 28px;
//     }
//     .title {
//       line-height: 1.2;
//       font-size: 22px;
//     }
//   }
// `;

export const Add = styled.div`
  .ad-box {
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    max-width: 300px;
    text-align: center;
  }

  .ad-title {
    font-size: 24px;
    margin-bottom: 10px;
    color: #333;
  }

  .ad-description {
    font-size: 16px;
    margin-bottom: 10px;
    color: #666;
  }

  .ad-message {
    font-size: 14px;
    margin-bottom: 20px;
    color: #bb1302;
    font-weight: bold;
  }

  .ad-contact a {
    color: #58a4ae;
    text-decoration: none;
    font-size: 16px;
  }

  .ad-contact a:hover {
    text-decoration: underline;
  }
`;
